import { AgreementAttachment } from '@libs/api-reference';
import { Ref } from 'vue';
import { UseQueryConfigV2, useQueryV2 } from '@libs/use';

import * as API from '../requests';
import { USER_QUERY_KEYS } from '../constants';

type UseGetAgreementTextOptions = {
  id: Ref<number | undefined>;
  onSuccess?: UseQueryConfigV2<AgreementAttachment>['onSuccess'];
  onReject?: UseQueryConfigV2<AgreementAttachment>['onReject'];
};

export default function useGetAgreementText({
  id,
  onSuccess,
  onReject,
}: UseGetAgreementTextOptions) {
  const { execute: getAgreementText, ...query } =
    useQueryV2<AgreementAttachment>(
      () => API.getAgreementText(id.value as number),
      {
        key: USER_QUERY_KEYS.agreementText(id),
        onSuccess,
        onReject,
        immediate: false,
      }
    );

  return {
    getAgreementText,
    ...query,
  };
}
